<template>
  <div class="yzldInfoPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <van-cell-group class="forestInput" v-if="!showNonePage">
      <van-field
        :value="baseData.xiaoBan ? baseData.xiaoBan : $t('common.noneText')"
        label="小班号："
      />
      <van-field
        class="beizhu"
        :value="
          baseData.regionName ? baseData.regionName : $t('common.noneText')
        "
        type="textarea"
        readonly
        rows="1"
        autosize
        label="政区："
      />
      <van-field
        :value="baseData.diMing ? baseData.diMing : $t('common.noneText')"
        readonly
        label="小地名："
      />
      <van-field
        :value="baseData.linBan ? baseData.linBan : $t('common.noneText')"
        readonly
        label="林班："
      />
      <van-field
        :value="baseData.linZhong ? baseData.linZhong : $t('common.noneText')"
        readonly
        label="林种："
      />
      <van-field
        :value="baseData.shuZhong1 ? baseData.shuZhong1 : $t('common.noneText')"
        readonly
        label="树种1："
      />
      <van-field
        :value="baseData.shuZhong2 ? baseData.shuZhong2 : $t('common.noneText')"
        readonly
        label="树种2："
      />
      <van-field
        class="lbStyle"
        :value="baseData.quanShu ? baseData.quanShu : $t('common.noneText')"
        readonly
        label="权属："
      />
      <van-field
        :value="baseData.diMao ? baseData.diMao : $t('common.noneText')"
        readonly
        label="地貌："
      />
      <van-field
        :value="
          baseData.haiBa ? baseData.haiBa + '(米)' : $t('common.noneText')
        "
        readonly
        label="海拔："
      />
      <van-field
        :value="baseData.zlDl ? baseData.zlDl : $t('common.noneText')"
        readonly
        label="造林地类型："
      />
      <van-field
        :value="baseData.zlFs ? baseData.zlFs : $t('common.noneText')"
        readonly
        label="造林方式："
      />
      <van-field
        :value="baseData.gcJb ? baseData.gcJb : $t('common.noneText')"
        readonly
        label="工程类别："
      />
      <!-- <van-field :value="baseData.bcld" readonly label="补充林地：" /> -->
      <van-field
        :value="baseData.hjFs ? baseData.hjFs : $t('common.noneText')"
        readonly
        label="混交方式："
      />
      <van-field
        :value="
          baseData.sbMj ? baseData.sbMj + '(公顷)' : $t('common.noneText')
        "
        readonly
        label="上报面积："
      />
      <van-field
        :value="
          baseData.hgMj ? baseData.hgMj + '(公顷)' : $t('common.noneText')
        "
        readonly
        label="合格面积："
      />
      <van-field
        :value="baseData.tcHd ? baseData.tcHd + '(米)' : $t('common.noneText')"
        readonly
        label="图层层厚："
      />
      <van-field
        :value="
          baseData.zhuJu ? baseData.zhuJu + '(米)' : $t('common.noneText')
        "
        readonly
        label="株距："
      />
      <van-field
        :value="
          baseData.hangJu ? baseData.hangJu + '(米)' : $t('common.noneText')
        "
        readonly
        label="行距："
      />
      <van-field
        :value="baseData.poDu ? baseData.poDu : $t('common.noneText')"
        readonly
        label="坡度："
      />
      <van-field
        :value="baseData.chl ? baseData.chl + '(%)' : $t('common.noneText')"
        readonly
        label="成活率："
      />
    </van-cell-group>
  </div>
</template>
<script>
/*eslint-disable*/

// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "yzldInfo",
  data() {
    return {
      showNonePage: true,
      yzldId: "",
      baseData: {},
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.yzldId = this.$route.query.commonId;
      if (this.yzldId == undefined) {
        this.yzldId = this.dataInfo.id;
      }
      this.initPage();
    });
  },

  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal.yzld
        .yzldDetaisl(_this.yzldId)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.showNonePage = false;
            _this.baseData = Object.assign({}, _this.baseData, res.data);
          } else {
            console.log(res.msg);
            _this.showNonePage = false;
          }
        })
        .catch((err) => {
          console.log(err);
          _this.showNonePage = false;
        });
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;
        _this.yzldId = this.dataInfo.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.yzldInfoPage {
  width: 100%;
  > p.fgx {
    width: 100%;
    height: 5px;
    background-color: #f6f6f6;
  }

  .forestInput {
    .van-cell {
      .van-field__label {
        color: #666;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }
    .beizhu {
      min-height: 45px;
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
}
</style>